import React, { useEffect, useRef } from "react";
import { api } from "../lib/api";

export default function AuthCallback() {
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        window.location.replace("/login");
        return;
      }
      try {
        await api.post("/auth/session", { session_id: sessionId });
        // Full reload to a clean URL; AuthProvider will pick up the cookie session.
        window.location.replace("/");
      } catch (e) {
        window.location.replace("/login");
      }
    };
    run();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F7]" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <div className="flex gap-1.5">
          <span className="omni-dot" />
          <span className="omni-dot" style={{ animationDelay: "0.2s" }} />
          <span className="omni-dot" style={{ animationDelay: "0.4s" }} />
        </div>
        <p className="text-sm text-[#5F5F5B] font-heading">Signing you in…</p>
      </div>
    </div>
  );
}
